import * as React from 'react';
import * as cx from 'classnames';
import SuperCritical from 'lib/supercritical';
import { tzmoment } from 'lib/tzmoment';
import { TopicCardStatus } from 'server/enums/TopicCardStatus';
import { TopicCardListItem } from './model';
import { PCTooltip } from 'portcall/pctooltip/view';

interface TopicCardListItemProps {
    model : TopicCardListItem;
    className? : string;
    hideLastUpdate? : () => boolean;
    onClick? : () => void;
}

export const TopicCardListItemView = SuperCritical(({ model: m, className, hideLastUpdate, onClick } : TopicCardListItemProps) =>
    <div className={cx('topic-card-list-item pc-topic-card-list-item', {
            clickable: !!onClick
        }, className)}
        onClick={onClick}>
        <div className="card-title">{m.Model.Title()}</div>
        <div className="card-remarks">{m.Model.Remarks()}</div>
        <div className="card-comments-and-date pc-text-smalllabel">
            {!(hideLastUpdate && hideLastUpdate()) &&
                <PCTooltip className="card-last-updated" title={() => tzmoment(m.LastUpdated()).format('MM/DD/YY [at] HH:mm')}>
                    last update {tzmoment(m.LastUpdated()).from(m.Now())}
                </PCTooltip>
            }
            <span>
                {m.Model.Comments().length} Comments
            </span>
        </div>
        <CardStatusView model={m} stopStatusClickPropagation={!!onClick} />
    </div>
);

let CardStatusView = SuperCritical(({ model: m, stopStatusClickPropagation } : { model: TopicCardListItem, stopStatusClickPropagation : boolean }) => {
    const possiblyStopPropagation = (clickHandler : (() => void) | undefined) => (e : React.SyntheticEvent<any>) => {
        stopStatusClickPropagation && e.stopPropagation();
        clickHandler && clickHandler();
    };

    return (
        <div className="card-status">
            {
                m.Model.Status() === TopicCardStatus.Confirmed ?
                    <span>
                        <span className="confirm readonly">Confirmed</span>
                        <span className={cx('withdraw', {
                                disabled: !m.CanConfirm()
                            })}
                            onClick={possiblyStopPropagation(m.CanConfirm() ? m.WithdrawConfirmation : undefined)}>
                            Withdraw
                        </span>
                    </span>
              : m.Model.Status() === TopicCardStatus.Denied ?
                    <span>
                        <span className="deny readonly">Denied</span>
                        <span className={cx('withdraw', {
                                disabled: !m.CanConfirm()
                            })}
                            onClick={possiblyStopPropagation(m.CanConfirm() ? m.WithdrawDenial : undefined)}>
                            Withdraw
                        </span>
                    </span>
              : m.Model.Status() === TopicCardStatus.PendingReview ?
                    <span>
                        <span className={cx('confirm', {
                                disabled: !m.CanConfirm()
                            })}
                            onClick={possiblyStopPropagation(m.CanConfirm() ? m.Confirm : undefined)}>
                            Confirm
                        </span>
                        <span className={cx('deny', {
                                disabled: !m.CanConfirm()
                            })}
                            onClick={possiblyStopPropagation(m.CanConfirm() ? m.Deny : undefined)}>
                            Deny
                        </span>
                    </span>
              : null
            }
        </div>
    );
});


// WEBPACK FOOTER //
// ./apps/portcall/topiccardlistitem/view.tsx